import {api} from 'services/api';
import {ResponseData} from 'types/response-data';
import {HomePageSettings} from 'types/home-page';

const updateHomePageSettings = api.injectEndpoints({
  endpoints: builder => ({
    updateHomePageSettings: builder.mutation<
      Response,
      UpdateHomePageSettingsRequest
    >({
      query: params => ({
        method: 'PUT',
        url: `settings/web-home-page`,
        body: params,
      }),
      // @ts-expect-error
      invalidatesTags: ['HomePageSettings'],
    }),
  }),
});

export type UpdateHomePageSettingsRequest = {
  sections: {
    order: number;
    section: string;
    title: {fr: string; en: string};
    file_id?: string | number | null;
  }[];
};

type Response = ResponseData<HomePageSettings>;

export const {useUpdateHomePageSettingsMutation} = updateHomePageSettings;

export const updateHomePageSettingsEndpoint =
  updateHomePageSettings.endpoints.updateHomePageSettings;
